import { ApplicationState } from '@/store';
import { getItemRequest } from '@/store/item/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface Props {
    contentPath: string;
    contentId: number;
}

const VideoProcessingAlert: React.FC<Props> = (props: Props) => {
    const { contentId, contentPath } = props;

    const dispatch = useDispatch();

    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const [checkConversionInterval, setCheckConversionInterval] = useState<NodeJS.Timeout | undefined>(undefined);
    const [fileOnQueueToConvert, setFileOnQueueToConvert] = useState<boolean>(false);

    const clearConversionInterval = (): void => {
        if (checkConversionInterval) {
            clearInterval(checkConversionInterval as NodeJS.Timeout);
            setCheckConversionInterval(undefined);
        }
    };

    useEffect(() => {
        if (contentPath) {
            setFileOnQueueToConvert(!contentPath.startsWith('/static'));
        }
    }, [contentPath]);

    useEffect(() => {
        if (fileOnQueueToConvert && checkConversionInterval === undefined) {
            setCheckConversionInterval(
                setInterval(() => {
                    dispatch(getItemRequest(contentId, true));
                }, 3000),
            );
        } else {
            clearConversionInterval();
        }
    }, [dispatch, fileOnQueueToConvert]);

    useEffect(() => {
        return () => {
            clearConversionInterval();
        };
    }, [checkConversionInterval]);

    if (!fileOnQueueToConvert) {
        return null;
    }

    return (
        <div className="video-processing-alert">
            <div className="alert alert-danger">
                <p className="attention">{strings.VIDEO_PROCESSING}</p>
                <p>{strings.WAIT_FEW_MINUTES}</p>
            </div>
        </div>
    );
};

export default VideoProcessingAlert;
